export default {
  introduce: 'Kilimall seller Center',
  Bangladesh: 'Bangladesh',
  Pakistan: 'Pakistan',
  Burma: 'Myanmar',
  Laos: 'Sri Lanka',
  Nepal: 'Nepal',
  question: 'Question'
}
